import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

const Article = ({ Link, Title, Description, onClick, ImageUrl, CategoryButtonText, CategoryDisplayName }) => {
    return (
        <a href={Link} title={Title} onClick={onClick} className="d-block item-tile article-tile">
            <div className="article-inner row">
                {ImageUrl &&
                    <div className="col-12 col-lg-4 search-result-img px-0 px-md-2">
                        <img
                            src={ImageUrl}
                            alt={CategoryDisplayName}
                            className="img-fluid"
                        />
                    </div>
                }
                <div className="col-12 col-lg-8">
                    <div className="d-flex justify-content-start pb-2">
                        <div className="text-sm-left">{CategoryDisplayName}</div>
                    </div>
                    <h5 className="headline headline-xs" dangerouslySetInnerHTML={{__html: Title}}></h5>
                    <div className="body-text text-sm" dangerouslySetInnerHTML={{__html: Description}}></div>
                </div>
            </div>
        </a>
    );
}


Article.propType = {
    Link: PropTypes.string,
    Title: PropTypes.string,
    Description: PropTypes.string,
    ImageUrl: PropTypes.string,
    onClick: PropTypes.func
};

export default Article;
